import { create } from "zustand"
import { immer } from "zustand/middleware/immer"
import type { CommunityBoard } from "../types"

interface BoardStoreState {
  entities: Record<string, CommunityBoard>  // slug → CommunityBoard
  allSlugs: string[]
}

interface BoardStoreActions {
  setBoards: (boards: CommunityBoard[]) => void
}

export const useBoardStore = create<BoardStoreState & BoardStoreActions>()(
  immer((set) => ({
    entities: {},
    allSlugs: [],
    setBoards: (boards) => set((state) => {
      state.allSlugs = boards.map((b) => b.slug)
      for (const board of boards) {
        state.entities[board.slug] = board
      }
    }),
  }))
)
